export const TOWN_HALL_LINK = 'https://app.towns.com/t/0x7d6936b6dbe77cda7d93fece27cdbb4daadd1ac7/'

export const PRICING_LEARN_MORE_LINK =
    'https://townhall.towns.com/Town-Hall-9e5c8120218d489392e8a72aef8c0326?p=2edea6a280cb46279762d9dca2b7be41&pm=c'

export const BRIDGE_LEARN_MORE_LINK =
    'https://townhall.towns.com/Town-Hall-9e5c8120218d489392e8a72aef8c0326?p=1113562b1f4e80038694ec973a871b09&pm=c'

export const MESSAGING_IN_TOWNS_LINK =
    'https://townhall.towns.com/Messaging-in-Towns-4eb893c9e34444b49ad49e368b9ab123?pvs=4'

export const TOWNS_IOS_APP = 'https://apps.apple.com/app/apple-store/id6504000393?pt=120981930&mt=8'

export const TOWNS_PRICING_TERMS_LINK =
    'https://townhall.towns.com/All-About-Pricing-2edea6a280cb46279762d9dca2b7be41'
